import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk, } from "@reduxjs/toolkit";

export const getMhsStatus = createAsyncThunk("dashboard/getMhsStatus", async () => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get("v1/dashboard/mhs/status");
    return response.data;
});

export const getMhsStatusByProdi = createAsyncThunk("dashboard/getMhsStatusByProdi", async (val) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/mhs/prodi/status/${val}`);
    return response.data;
});

export const getStatusNidnDosen = createAsyncThunk("dashboard/getStatusNidnDosen", async () => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get("v1/dashboard/dosen/nidn");
    return response.data;
});

export const getStatusDosenAll = createAsyncThunk("dashboard/getStatusDosenAll", async () => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get("v1/dashboard/dosen/status");
    return response.data;
});

export const getSksTaken = createAsyncThunk("dashboard/getSksTaken", async (val) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/sks/taken/${val}`);
    return response.data;
});

export const getDashIpsIpk = createAsyncThunk("dashboard/getDashIpsIpk", async (val) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get(`v1/indeks/prestasi/dashboard/by_nim/${val}`);
    return response.data;
});

export const getDashDurasiMengajarDosen = createAsyncThunk("dashboard/getDashDurasiMengajarDosen", async (val) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/dosen/durasi/${val}`);
    return response.data;
});


export const getDashPerwalianDosen = createAsyncThunk("dashboard/getDashPerwalianDosen", async (val) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/dosen/perwalian/${val}`);
    return response.data;
});

export const getDashKeuanganAll = createAsyncThunk("dashboard/getDashKeuanganAll", async (val) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/keuangan/all`);
    return response.data;
});

export const getDashKeuanganProdi = createAsyncThunk("dashboard/getDashKeuanganProdi", async (val) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/keuangan/prodi`);
    return response.data;
});

export const getDashKeuanganStatus = createAsyncThunk("dashboard/getDashKeuanganStatus", async (val) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/keuangan/status`);
    return response.data;
});

export const getDashKeuanganRekber = createAsyncThunk("dashboard/getDashKeuanganRekber", async (val) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/keuangan/rekber`);
    return response.data;
});

export const getDashKeuanganTransfered = createAsyncThunk("dashboard/getDashKeuanganTransfered", async (val) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/keuangan/transfered`);
    return response.data;
});

const initialState = {
    loading: false,
    loadingDosenNidn: false,
    dataMhsStatus: [],
    dataSksTaken: [],
    dataMhsStatusProdi: [],
    dataDosenNidn: [],
    dataDashIpsIpk: {},
    dataDosenDurasiMengajar : {},
    dataDosenPerwalian : {},
    dataDashKeuanganAll : {},
    dataDashKeuanganRekber : {},
    dataDashKeuanganTransfered : {},
    dataDashStatusPayment:{
        total : 0,
        listLabel : ['Sudah Bayar', 'Belum Bayar'],
        listValue : [0, 0],
        title : "Pembayaran",
        data : [
            {id : true, count : 0 },
            {id : false, count : 0 }
        ]
    },
    dataDashStatusDosen : {
        total : 0,
        label : "STATUS_DOSEN",
        data : [
            {id : 'AKTIF', count : 0 },
            {id : 'TIDAK_AKTIF', count : 0 }
        ]
    },
    dataDashKeuanganProdi: []
};

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getDashKeuanganRekber.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDashKeuanganRekber.fulfilled, (state, action) => {
                state.dataDashKeuanganRekber = action.payload;
                state.loading = false;
            })
            .addCase(getDashKeuanganRekber.rejected, (state, action) => {
                state.loading = false;
            });

        builder
            .addCase(getDashKeuanganTransfered.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDashKeuanganTransfered.fulfilled, (state, action) => {
                state.dataDashKeuanganTransfered = action.payload;
                state.loading = false;
            })
            .addCase(getDashKeuanganTransfered.rejected, (state, action) => {
                state.loading = false;
            });

        builder
            .addCase(getDashKeuanganStatus.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDashKeuanganStatus.fulfilled, (state, action) => {
                state.dataDashStatusPayment = action.payload;
                state.loading = false;
            })
            .addCase(getDashKeuanganStatus.rejected, (state, action) => {
                state.loading = false;
            });

        builder
            .addCase(getStatusDosenAll.pending, (state) => {
                state.loading = true;
            })
            .addCase(getStatusDosenAll.fulfilled, (state, action) => {
                state.dataDashStatusDosen = action.payload;
                state.loading = false;
            })
            .addCase(getStatusDosenAll.rejected, (state, action) => {
                state.loading = false;
            });

        builder
            .addCase(getDashKeuanganProdi.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDashKeuanganProdi.fulfilled, (state, action) => {
                state.dataDashKeuanganProdi = action.payload;
                state.loading = false;
            })
            .addCase(getDashKeuanganProdi.rejected, (state, action) => {
                state.loading = false;
            });

        builder
            .addCase(getDashKeuanganAll.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDashKeuanganAll.fulfilled, (state, action) => {
                state.dataDashKeuanganAll = action.payload;
                state.loading = false;
            })
            .addCase(getDashKeuanganAll.rejected, (state, action) => {
                state.loading = false;
            });

        builder
            .addCase(getDashPerwalianDosen.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDashPerwalianDosen.fulfilled, (state, action) => {
                state.dataDosenPerwalian = action.payload;
                state.loading = false;
            })
            .addCase(getDashPerwalianDosen.rejected, (state, action) => {
                state.loading = false;
            });
        builder
            .addCase(getDashDurasiMengajarDosen.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDashDurasiMengajarDosen.fulfilled, (state, action) => {
                state.dataDosenDurasiMengajar = action.payload;
                state.loading = false;
            })
            .addCase(getDashDurasiMengajarDosen.rejected, (state, action) => {
                state.loading = false;
            });
        builder
            .addCase(getMhsStatus.pending, (state) => {
                state.loading = true;
            })
            .addCase(getMhsStatus.fulfilled, (state, action) => {
                state.dataMhsStatus = action.payload;
                state.loading = false;
            })
            .addCase(getMhsStatus.rejected, (state, action) => {
                state.loading = false;
            });
        builder
            .addCase(getStatusNidnDosen.pending, (state) => {
                state.loadingDosenNidn = true;
            })
            .addCase(getStatusNidnDosen.fulfilled, (state, action) => {
                state.dataDosenNidn = action.payload;
                state.loadingDosenNidn = false;
            })
            .addCase(getStatusNidnDosen.rejected, (state, action) => {
                state.loadingDosenNidn = false;
            });
        builder
            .addCase(getMhsStatusByProdi.pending, (state) => {
                state.loading = true;
            })
            .addCase(getMhsStatusByProdi.fulfilled, (state, action) => {
                state.dataMhsStatusProdi = action.payload;
                state.loading = false;
            })
            .addCase(getMhsStatusByProdi.rejected, (state, action) => {
                state.loading = false;
            });
        builder
            .addCase(getSksTaken.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSksTaken.fulfilled, (state, action) => {
                state.dataSksTaken = action.payload;
                state.loading = false;
            })
            .addCase(getSksTaken.rejected, (state, action) => {
                state.loading = false;
            });
        builder
            .addCase(getDashIpsIpk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDashIpsIpk.fulfilled, (state, action) => {
                state.dataDashIpsIpk = action.payload;
                state.loading = false;
            })
            .addCase(getDashIpsIpk.rejected, (state, action) => {
                state.loading = false;
            });
    },
});

export const dashboardSelectors = (state) => state.dashboard;
export default dashboardSlice.reducer;
